import * as z from "zod/v4";

export const generateDiscountCode = {
  name: "generateDiscountCode" as const,
  input: z.object({
    selectedPointsToSpend: z.number().int().min(0),
    shopifyCustomerId: z.string(),
  }),
  output: z.object({
    discountCode: z.string(),
    discountValue: z.string(),
    pointsRedeemed: z.number().int(),
  }),
};
